// extracted by mini-css-extract-plugin
module.exports = {"svg":"modal-1-bars-1-module--svg--2C1-J"};